export default __webpack_public_path__ + "static/media/ortheo-grid-02.efda6b70.svg";